import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render({ name }) {
        return (
            <email-unsubscribe-landing>
                <row className='is-wrap'>
                    <column className='is-12-mobile is-6 is-push-6-tablet is-push-6-desktop has-text-center-mobile'>
                        <img src='https://gfx.tarot.com/images/site/tarot/unsub/fool.gif' alt='The Fool' />
                    </column>
                    <column className='is-12-mobile is-6 is-pull-6-tablet is-pull-6-desktop has-text-center-mobile'>
                        <h6>SAY IT AIN'T SO!</h6>
                        <h1>Is This Really Goodbye?</h1>
                        <hr />
                        <h3>Are you sure you want to stop receiving <b>{name}</b> emails?</h3>
                        <row>
                            <column className='is-12-mobile is-10'>
                                <a href='#opt-out' className='button-warning-alternate'>YES, UNSUBSCRIBE ME</a>
                            </column>
                        </row>
                        <row>
                            <column className='is-12-mobile is-10'>
                                <a href='#keep' className='button-warning'>NO, KEEP 'EM COMING</a>
                            </column>
                        </row>
                        <br />
                        <a href='/member/emails' className='manage'>Manage your email preferences</a>
                        <br />
                    </column>
                </row>
            </email-unsubscribe-landing>
        );
    }
}

const mapStateToProps = (state) => ({
    name: state['email-unsub'] && state['email-unsub'].name,
});

export default connect(mapStateToProps)(Component);


